module.exports = __webpack_public_path__ + "img/logo-koinvesticinis-fondas.1b31c5e.svg";